import React from 'react'
import {graphql, Link, useStaticQuery} from 'gatsby'
import starIcon from '../../assets/images/star-icon.png'

const query = graphql`{
    allStrapiProduct {
        edges {
          node {
            title
            activeTitle
            slug
            ProductsCategory
            categoryImage {
              url
              alternativeText
            }
            CategorySubHeading
        }
    }
  }
}`
const RecentProjects = () => {
    const product = useStaticQuery(query)
    const productsCategory = product?.allStrapiProduct?.edges
    const category = [...new Set(productsCategory.map(category => category?.node?.ProductsCategory))]
    const subHead = [...new Set(productsCategory.map(category => category?.node?.CategorySubHeading))]
    const subHeadMapping = {
        "Productivity Tools": 0,
        "Quality Control Management": 1,
        "HealthCare Software Development": 3,
    }
    console.log(category,"categorycategorycategory");
    console.log(subHead,"subHeadsubHeadsubHead");
    
    return (

        <section className="projects-area products-project-area bg-color pt-50 pb-70">
            <div className="container">
                <div className="section-title">
                    <h2 className="sub-title products-section-heading">
                        <img src={starIcon} alt="project" /> Our Products
                    </h2>
                    <p> Committed to delivering high quality products and innovate design solutions.</p>
                </div>
                {category.filter(cat => cat !== null)
                .map((category, index) => {
                    const headIndex = subHeadMapping[category]
                    const headText = headIndex !== undefined ? subHead[headIndex] : null
                    
                    return (
                        <fieldset key={index}>
                            <legend><p className="products-category-title">{category}</p></legend>
                            {headText && (
                                <p className="text-center py-4">{headText}</p>
                            )}
                            <div className="row justify-content-center">
                                {productsCategory.map((products, index) => {
                                    return (products?.node?.ProductsCategory === category &&
                                            <div className="col-lg-4 col-md-6" key={index}>
                                                <div className="single-projects-box">
                                                    <div className="image">
                                                        <img style={{ height: '190px' }} src={products?.node?.categoryImage?.url} alt={products?.node?.categoryImage?.alternativeText || "project"} />

                                                        <Link className="link-btn" to={products?.node?.slug}>
                                                            <i className='bx bx-plus'></i>
                                                        </Link>
                                                    </div>

                                                    <div className="content">
                                                        <h3>
                                                            <Link to={products?.node?.slug}>
                                                                {products?.node?.activeTitle}
                                                            </Link>
                                                        </h3>
                                                        <span>{products?.node?.title}</span>
                                                    </div>
                                                </div>
                                            </div>
                                    ) 
                                })}
                            </div>
                        </fieldset>
                    );
                })}

            </div>

        </section>
        

    )
}

export default RecentProjects;